import './style.css';

import { bind } from 'bind-decorator';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import Text from '../../../clinical/clinical-text';
import TimeDurationPicker from './controls/time-duration-picker';
import type TimeDurationProps from './interfaces/time-duration-props';

@observer
class TimeDuration extends Component<TimeDurationProps> {
  @observable
  units: Array<string>;
  @observable
  hintText: string;

  constructor(props: TimeDurationProps) {
    super(props);

    this.units = ['days', 'weeks', 'months'];
    if (props.includeYears) {
      this.units.push('years');
    }
    this.hintText = `e.g. 1 day, 2w, 3Months`;
  }

  render() {
    const { errored, warning, fieldsMode, value, readOnly, label, inline } = this.props;
    const { onBlur, onChange, units, hintText } = this;
    if (fieldsMode) {
      return <TimeDurationPicker units={units} {...this.props} onBlur={onBlur} />;
    } else {
      return (
        <Text
          label={label}
          inline={inline}
          errored={errored}
          warning={warning}
          onChange={onChange}
          onBlur={onBlur}
          readOnly={readOnly}
          value={value}
          placeholder={hintText}
          liveOnChange={true}
        />
      );
    }
  }

  @bind
  onChange(value: string) {
    this.props.onChange(value);
  }

  @bind
  onBlur() {
    const { units } = this;
    let val = this.props.value;
    let reg = new RegExp(
      `\\d{1,3}\\s?[` +
        units.map((u) => {
          return u.charAt(0);
        }) +
        `]{1,6}\\s?`,
      `i`
    );

    if (!!val && val.match(reg)) {
      const qMatch = val.match(/\d{1,3}\s?/);
      const uMatch = val.match(/\s?[a-zA-Z]{1,6}/);
      if (qMatch && uMatch) {
        const quantity = qMatch[0].trim();
        const unitChar = uMatch[0].trim().toLowerCase().charAt(0);
        let unit = units.find((u) => u.charAt(0) === unitChar) || '';

        if (parseInt(quantity) === 1) {
          unit = unit.slice(0, -1);
        }
        val = `${quantity} ${unit}`;
      }
    } else {
      if (val !== '') {
        let hintText = `This value can only be defined in `;

        units.forEach((u, idx) => {
          if (idx !== units.length - 1) {
            hintText += `${units[idx]}, `;
          } else {
            hintText += `or ${units[idx]}. e.g. 1 day, 2w, 3Months`;
          }
        });
        this.hintText = hintText;
        val = '';
      }
    }
    this.props.onChange(val);
  }
}

export default TimeDuration;

export { TimeDuration };
